import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { connect } from 'react-redux';
import { compose, lifecycle, withProps, withPropsOnChange } from 'recompose';
import { getCustomFieldDefinitionsAction } from "../../api/jsonapi";
import lazyLoad from "../../util/lazyLoad";
import componentErrorBoundary from "../enhancers/componentErrorBoundary";
import { buildObjectListCached } from "../../util/redux";
import handleApiErrorResponse from "../../util/handleApiErrorResponse";
import { customFieldsNewFieldsSelector, customFieldsCreateAction, customFieldsRemoveAction } from '@applyboard/ab-common';
import customFieldsFetchHelper from "./customFieldsFetchHelper";
var getCustomFields = buildObjectListCached('custom_fields');
export var enhancer = compose(componentErrorBoundary, lazyLoad('customFieldDefinitions', getCustomFieldDefinitionsAction, undefined, undefined, handleApiErrorResponse), connect(function (state) {
  return {
    customFields: getCustomFields(state),
    newFields: customFieldsNewFieldsSelector(state)
  };
}, function (dispatch) {
  return {
    onInsertField: function onInsertField() {
      return dispatch(customFieldsCreateAction());
    },
    onRemoveField: function onRemoveField(id) {
      return dispatch(customFieldsRemoveAction(id));
    }
  };
}), withPropsOnChange(['hasPermission'], function (_ref) {
  var hasPermission = _ref.hasPermission;
  var fetchStudentCustomFields = false;
  if (hasPermission('show_custom_field') || hasPermission('show_custom_field_student')) {
    fetchStudentCustomFields = true;
  }
  var fetchApplicationCustomFields = false;
  if (hasPermission('show_custom_field_application')) {
    fetchApplicationCustomFields = true;
  }
  return {
    fetchStudentCustomFields: fetchStudentCustomFields,
    fetchApplicationCustomFields: fetchApplicationCustomFields
  };
}), customFieldsFetchHelper(), withProps(function (_ref2) {
  var customFieldDefinitions = _ref2.customFieldDefinitions,
    customFields = _ref2.customFields,
    newFields = _ref2.newFields,
    applicationId = _ref2.applicationId;
  return {
    customFields: customFields.concat(newFields || []),
    customFieldDefinitions: !!applicationId || !customFieldDefinitions ? customFieldDefinitions : customFieldDefinitions.filter(function (_ref3) {
      var custom_field_type = _ref3.attributes.custom_field_type;
      return custom_field_type !== 'application';
    })
  };
}), withProps(function (_ref4) {
  var customFieldDefinitions = _ref4.customFieldDefinitions,
    customFields = _ref4.customFields;
  if (!customFieldDefinitions || !customFields) return {};
  var currentCustomFieldsKeys = customFields.map(function (field) {
    return field.key;
  });
  return {
    customFieldDefinitions: customFieldDefinitions.filter(function (_ref5) {
      var key = _ref5.attributes.key;
      return !currentCustomFieldsKeys.includes(key);
    })
  };
}), withProps(function (_ref6) {
  var status = _ref6.status,
    studentId = _ref6.studentId,
    applicationId = _ref6.applicationId;
  var isLoading = status.customFieldDefinitions.isLoading || !status.customFieldDefinitions.hasStarted;
  isLoading = isLoading || studentId && (status.studentCustomFields.isLoading || !status.studentCustomFields.hasStarted);
  isLoading = isLoading || applicationId && (status.applicationCustomFields.isLoading || !status.applicationCustomFields.hasStarted);
  return {
    isLoading: isLoading
  };
}), withPropsOnChange(['customFields', 'isLoading'], function (_ref7) {
  var onUpdate = _ref7.onUpdate,
    isLoading = _ref7.isLoading,
    customFields = _ref7.customFields;
  if (!isLoading && typeof onUpdate === 'function') {
    onUpdate(customFields);
  }
}), lifecycle({
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
      isLoading = _this$props.isLoading,
      customFields = _this$props.customFields,
      onUpdate = _this$props.onUpdate;
    if (customFields && !isLoading && typeof onUpdate === 'function') {
      onUpdate(customFields);
    }
  }
}));
export default enhancer;